module.exports = __webpack_public_path__ + "img/consult_info3.5f3c31d7.png";